export default __webpack_public_path__ + "static/media/bookThumbnail.1399b42d.png";